export default __webpack_public_path__ + "static/media/promotion-banner-one-mobile.04800502.png";